module.exports = __webpack_public_path__ + "assets/favicons/android-chrome-192x192.704a8cbc21f8864becab239d399ace22.png";